<template>
  <v-container fluid>
    <v-btn icon @click="$router.back()">
      <v-icon>mdi-arrow-left</v-icon>
    </v-btn>
    <span class="display-1 pl-3" id="title">担当者一覧</span>

    <v-row align="center" justify="center" dense>
      <v-col cols="12" xl="12" dense>
        <v-card v-if= "!isSystemAdmin" flat outlined class="ma-5 pa-3">
          <div class="subtitle-2 mb-2">
            <v-icon class="mr-1" color="primary" small>mdi-information-outline</v-icon>
            <span class="primary--text">担当者管理機能について</span>
          </div>
          <p class="caption">
              この機能はシステム管理者のみ利用できる機能です。<br>
          </p>
        </v-card>
      </v-col>
    </v-row>

    <v-row v-if= "isSystemAdmin" align="center" justify="center" dense>
      <v-col cols="12">
        <div>
          <v-text-field
            v-model="search"
            prepend-inner-icon="mdi-magnify"
            placeholder="検索"
            filled
          ></v-text-field>
        </div>
      </v-col>

      <v-col cols="12" xl="12" dense>
        総件数：{{items.length}}件
      </v-col>

      <v-col cols="12" xl="12" dense>
        <v-data-table
          :headers="headers"
          :items="items"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          :search="search"
          :sort-by="['EmployeeID']"
          :loading="loading"
          loading-text="読込中"
          no-data-text="データがありません。"          
          no-results-text="検索条件に該当するデータがありません。"                  
          hide-default-footer
          @page-count="pageCount = $event"
          @click:row="selectEmployee"
          fixed-header
        >

        </v-data-table>
      </v-col>
    </v-row>

    <v-row v-if= "isSystemAdmin" align="center" justify="center" dense>
      <v-col cols="10" lg="10" md='10' sm='10' xs="10">
        <v-pagination
         v-model="page"
         :total-visible="totalVisible"
         :length="pageCount"
         color="amber darken-1 black--text"
        light 
        circle
        @input="onPageChange">
        </v-pagination>
      </v-col>
      <v-col cols="4" lg="2"  md='4' sm='4' xs="6">
        <v-select
          :value="itemsPerPage"
          :items = "itemsPerPageList"
          label="1ページの行数"
          @input="itemsPerPage = $event"
        ></v-select>
      </v-col>
    </v-row>

    <v-dialog
      v-model="editEmployee"
      persistent
      max-width="90%"
    >
      <v-card outlined class="py-2">
        <v-card-title>
          担当者詳細
        </v-card-title>
        <v-card-text>
          <v-row dense class="mb-2">
            <v-col cols=4>
              <v-row dense>
                <v-col cols=4 dense class="font-weight-bold">担当者ID</v-col>
                <v-col cols=8 dense>{{employee.EmployeeID}}</v-col>
              </v-row>
            </v-col>
            <v-col cols=4>
              <v-row dense>
                <v-col cols=4 dense class="font-weight-bold">氏名</v-col>
                <v-col cols=8 dense>{{employee.Name}}</v-col>
              </v-row>
            </v-col>
            <v-col cols=4>
              <v-row dense>
                <v-col cols=4 dense class="font-weight-bold">氏名（カナ）</v-col>
                <v-col cols=8 dense>{{employee.NameKana}}</v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row dense class="mb-2">
            <v-col cols=4>
              <v-row dense>
                <v-col cols=4 dense class="font-weight-bold">会社名</v-col>
                <v-col cols=8 dense>{{employee.CompanyName}}</v-col>
              </v-row>
            </v-col>
            <v-col cols=4>
              <v-row dense>
                <v-col cols=4 dense class="font-weight-bold">事業所名</v-col>
                <v-col cols=8 dense>{{employee.OfficeName}}</v-col>
              </v-row>
            </v-col>
            <v-col cols=4>
              <v-row dense>
                <v-col cols=4 dense class="font-weight-bold">役職</v-col>
                <v-col cols=8 dense>{{employee.Position}}</v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row dense class="mb-2">
            <v-col cols=4>
              <v-row dense>
                <v-col cols=4 dense class="font-weight-bold">部署名</v-col>
                <v-col cols=8 dense>{{employee.DeptName}}</v-col>
              </v-row>
            </v-col>
            <v-col cols=4>
              <v-row dense>
                <v-col cols=4 dense class="font-weight-bold">郵便番号</v-col>
                <v-col cols=8 dense>{{office.Zip}}</v-col>
              </v-row>
            </v-col>
            <v-col cols=4>
              <v-row dense>
                <v-col cols=4 dense class="font-weight-bold">住所</v-col>
                <v-col cols=8 dense>{{office.Address1}} {{office.Address2}}</v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row dense class="mb-2">
            <v-col cols=4>
              <v-row dense>
                <v-col cols=4 dense class="font-weight-bold">電話番号</v-col>
                <v-col cols=8 dense>{{employee.Tel}}</v-col>
              </v-row>
            </v-col>
            <v-col cols=4>
              <v-row dense>
                <v-col cols=4 dense class="font-weight-bold">携帯番号</v-col>
                <v-col cols=8 dense>{{employee.Mobile}}</v-col>
              </v-row>
            </v-col>
            <v-col cols=4>
              <v-row dense>
                <v-col cols=4 dense class="font-weight-bold">FAX番号</v-col>
                <v-col cols=8 dense>{{employee.FAX}}</v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row dense class="mb-2">
            <v-col cols=4>
              <v-row dense>
                <v-col cols=4 dense class="font-weight-bold">メールアドレス</v-col>
                <v-col cols=8 dense>{{employee.email}}</v-col>
              </v-row>
            </v-col>
            <v-col cols=4>
              <v-row dense>
                <v-col cols=4 dense class="font-weight-bold">権限</v-col>
                <v-col cols=8 dense>{{employee.Permission}}</v-col>
              </v-row>
            </v-col>
            <v-col cols=4>
              <v-row dense>
                <v-col cols=4 dense class="font-weight-bold">UserPoolID</v-col>
                <v-col cols=8 dense>{{employee.UserPoolID}}</v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row dense class="mb-2">
            <v-col cols=4>
              <v-row dense>
                <v-col cols=4 dense class="font-weight-bold">登録日</v-col>
                <v-col cols=8 dense>{{formatDate(employee.createdAt)}}</v-col>
              </v-row>
            </v-col>
            <v-col cols=4>
              <v-row dense>
                <v-col cols=4 dense class="font-weight-bold">更新日</v-col>
                <v-col cols=8 dense>{{formatDate(employee.updatedAt)}}</v-col>
              </v-row>
            </v-col>
            <v-col cols=4>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn rounded color="body-2 amber darken-1 font-weight-bold"  @click="cancel()" class="mx-2 mb-5">
            <v-icon class="mr-2">mdi-close</v-icon>閉じる
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    </v-container>
</template>

<script>
import { fetchAllActiveEmployees } from '../utils/utils'
import { API, graphqlOperation } from "aws-amplify"
import { officeByKey } from '../graphql/queries'


export default {

  name: "MainteEmployee",
  mixins:[],
  head: {
    title: { inner: '担当者一覧'},
  },
  data() {
    return {
      page: 1,
      pageCount: 0,
      itemsPerPage: 100,
      itemsPerPageList: [ 50,100, ],
      totalVisible: 7,
      search: '',
      loading: false, 

      items: [],
      headers: [
        {
          text: '担当者ID',
          align: 'start',
          value: 'EmployeeID',
          class: "grey darken-2 white--text",
          width: "15%",
          sortable: true 
        },
        {
          text: '氏名',
          align: 'start',
          value: 'Name',
          class: "grey darken-2 white--text",
          width: "20%" ,
          sortable: true
        },
        {
          text: '会社名',
          align: 'start',
          value: 'CompanyName',
          class: "grey darken-2 white--text",
          width: "25%",
          sortable: true 
        },
        {
          text: '事業所名',
          align: 'start',
          value: 'OfficeName',
          class: "grey darken-2 white--text",
          width: "20%",
          sortable: true 
        },
        {
          text: 'メールアドレス',
          align: 'start',
          value: 'email',
          class: "grey darken-2 white--text",
          width: "20%",
          sortable: false 
        },
      ],
      editEmployee: false,
      employee: {},
      office: {},


    }
  },
  filters: {
  },
  computed: {
    isAdmin () {
      return this.$store.state.isAdmin
    },
    isSystemAdmin : function() {
      return this.$store.state.isSystemAdmin
    },
    isSuperUser : function() {
      return this.$store.state.isSuperUser
    },
  },
  mounted: async function () {
    this.initialize()
  },
  methods: {
    initialize: async function() {
      try {
        this.items = await fetchAllActiveEmployees()
      } catch (error) {
        console.error('データの取得に失敗しました:', error)
        this.items = []
      }
    },
    selectEmployee: async function(data) {
      this.employee = { ...data }
      await this.loadOffice(data.OfficeID)
      this.editEmployee = true
    },
    loadOffice: async function(officeID) {
      if (!officeID) {
        this.office = {}
        return
      }
      try {
        const result = await API.graphql(graphqlOperation(officeByKey, {
          OfficeID: officeID
        }))
        this.office = result.data.officeByKey.items[0] || {}
      } catch (error) {
        console.error('事業所データの取得に失敗しました:', error)
        this.office = {}
      }
    },



    formatDate: function(dateString) {
      if (!dateString) return ''
      const date = new Date(dateString)
      return date.toLocaleString('ja-JP', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      })
    },
    onPageChange: function() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    cancel: function() {
      this.editEmployee = false
      this.employee = {}
      this.office = {}
    }
  }
};
</script>